<app-accordion-help [helps]="helps"></app-accordion-help>
<ng-container *ngIf="is_loading">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-container>

<div style="margin-top: 20px; margin-left: 20px">
  <button mat-raised-button color="accent" (click)="goBack()">Back</button>
</div>


<ng-container *ngIf="!is_loading">


  <ng-container *ngIf="!is_redirect_url">
    <div style="margin-top: 20px; margin-left: 20px">
      <button mat-raised-button color="primary" (click)="submit()">Add Facebook Account</button>
    </div>
  </ng-container>

  <ng-container *ngIf="is_redirect_url">
    <div style="margin-top: 20px; margin-left: 20px">
      <button mat-raised-button color="primary" (click)="onPop()">Reauthorize</button>
      <button style ="margin-left: 10px" mat-raised-button color="warn"  (click)="onDelete()" [disabled]="!webhook_id" type="button">Delete</button>
    </div>
  </ng-container>

  <div style="margin-top: 20px; margin-left: 20px">
    <mat-slide-toggle [checked]="checked" [color]="color"> Connected</mat-slide-toggle>
  </div>


</ng-container> <!-- end is loading-->
